module.exports = __webpack_public_path__ + "img/Beginner-5.78c84c37.gif";